function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#636E95",
  fillRule: "nonzero",
  d: "M22.167 8.167h-3.5v-1.75c0-1.611-1.306-2.917-2.917-2.917h-3.5c-1.61 0-2.917 1.306-2.917 2.917v1.75h-3.5c-1.933 0-3.5 1.567-3.5 3.5V21c0 1.933 1.567 3.5 3.5 3.5h16.334c1.933 0 3.5-1.567 3.5-3.5v-9.333c0-1.933-1.567-3.5-3.5-3.5zM17.5 10.5v11.667h-7V10.5h7zm-5.833-4.083c0-.322.26-.584.583-.584h3.5c.322 0 .583.262.583.584v1.75h-4.666v-1.75zM4.667 21v-9.333c0-.645.522-1.167 1.166-1.167h2.334v11.667H5.833c-.644 0-1.166-.523-1.166-1.167zm18.666 0c0 .644-.522 1.167-1.166 1.167h-2.334V10.5h2.334c.644 0 1.166.522 1.166 1.167V21z"
}));

var SvgBriefcaseNormal = function SvgBriefcaseNormal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBriefcaseNormal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/briefcase-normal.a4cc0441.svg";
export { ForwardRef as ReactComponent };